import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JoiEvent, Ranking } from 'globals/store/events.data';
import { Exhibitor, exhibitorDisplayTypes, ExhibitorStand, exhibitorStandTabs } from 'globals/store/exhibitors.data';
import { ManageWrapperComponent, TabGroup } from '../manage/manage-wrapper.component';
import { manageSessionPermissionReselector, manageSessionStates } from 'src/app/store/reselectors/sessions.reselector';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { imageUploaderDisplayTypes } from 'globals/store/files.model';
import { ButtonListData, ButtonListDialogComponent } from 'src/app/components/dialogues-general/buttonList.dialog.component';
import { EntityRequest, Program } from 'globals/store/programs.data';
import { RankSelectDialogComponent, RankingDialogData } from '../sponsors/rank-select.dialog.component';
import { Wrapper } from 'src/app/components/wrapper.component';
import { Dictionary } from '@ngrx/entity';
import { ItemStatus, StandItemInfo, StandItemType } from 'globals/store/share.data';
import { EntitySelectorData, EntitySelectorDialogComponent } from 'src/app/components/entities/entity-selector.dialog.component';
import { generateEmailLink } from '../../helpers/helpers';
import { compactDate, jsonCopyObject, str2Date } from 'globals/helpers/helpers';
import { AssetsComponent } from '../assets/assets.component';
import { TitleIconComponent } from 'src/app/components/icon/title-icon.component';
import { AddManageWrapperComponent } from 'src/app/components/wrappers/add-manage-wrapper.component';
import { CommonModule } from '@angular/common';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { TipTextComponent } from 'src/app/components/misc/tip-text.component';
import { StagingRequestsComponent } from '../manage/staging-requests.component';
import { ShareStagingRequestComponent } from '../share/share.stagingRequest';
import { PerformerStagingRequestComponent } from 'src/app/components/performers/performerStagingRequestAdder.component';
import { ExhibitorsComponent } from './exhibitors.component';

@Component({
    selector: 'manage-exhibitor-stand',
    templateUrl: './manage-exhibitor-stand.html',
    styleUrls: ['../manage/manage-dialogs.scss'],
    standalone: true,
    imports: [ManageWrapperComponent, StagingRequestsComponent, PerformerStagingRequestComponent, ExhibitorsComponent, AssetsComponent, TipTextComponent, JoiInputComponent, CommonModule, TitleIconComponent, AddManageWrapperComponent],
})
export class ManageExhibitorStandDialogComponent extends Wrapper<ManageExhibitorStandDialogComponent> implements OnInit {
  exhibitorStand = <ExhibitorStand>{}
  
  imageUploaderDisplayTypes = imageUploaderDisplayTypes
  

  event: JoiEvent
  standTypes: { [id:string]: Ranking } = {}
  programs: { [pId:string]: Program } = {}
  exhibitors: Dictionary<Exhibitor> = {}
  tabs = exhibitorStandTabs
  
  tabGroups: TabGroup[] = [{ tabs: [
    { id: exhibitorStandTabs.details, name: 'Exhibitor stand details' },
    { id: exhibitorStandTabs.assets, name: 'Exhibitor stand assets' },
    { id: exhibitorStandTabs.requests, name: 'Exhibitor stand requests' },
  ]}]
  selectedTab
  readState = manageSessionStates.ReadOnly.toString()
  readStates = manageSessionStates
  assetHint = `Note: Exhibitor stand assets must be supplied through a file URL eg. Hosted on Dropbox or Google Drive. Individual file assets can’t be uploaded into Joi.\n\nOnce a submission is made the status will change from "Active" to "Submitted" and the link will be closed. To re-enable the link, change the status back to "Active".`
  eAsset: Dictionary<StandItemInfo>
  eRequest: Dictionary<StandItemInfo>
  requests: EntityRequest[]
  exhibitorDisplayTypes = exhibitorDisplayTypes;

  constructor(public changeDetectorRef: ChangeDetectorRef, public dialogRef: MatDialogRef<ManageExhibitorStandDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: ManageExhibitorStandData) {
    super()
    this.subCallback(this.store.select('events', 'event'), event => {
      this.event = event;
      this.exhibitorStand = jsonCopyObject(event.exhibitorStands[this.data.exhibitorStandId]);
      this.requests = this.exhibitorStand.requests;
    })
    this.subProp(this.store.select('programs', 'entities'), 'programs')
    this.subProp(this.store.select('exhibitors', 'standTypes'), 'standTypes')
    this.subProp(this.store.select('exhibitors', 'entities'), 'exhibitors')
    this.subProp(this.store.select('shareables','eAsset'), 'eAsset')
    this.subProp(this.store.select('shareables','eRequest'), 'eRequest')
  }

  ngOnInit() {
    this.subProp(this.store.select(manageSessionPermissionReselector), 'readState')
  }

  emailGenerator(publishCode: string) {
    const firstDate = this.event.first_date
    const dateText = firstDate ? `, ${compactDate(str2Date(firstDate))}` : ''
    const title = this.event.title || 'untitled event'
    const subject = `Information required for ${title}${dateText}`
    const body = `Hi there,\n\nCan you please click on the link below and submit any exhibitor stand requests you have for ${this.exhibitorStand.name || 'Unnamed exhibitor stand'}:\n\n${publishCode}\n\nThanks`
    return generateEmailLink(subject, body)
  }
  

  addAssetIds(ids: string[]) {
    this.exhibitorStand.assetIds = [...(this.exhibitorStand.assetIds || []), ...ids]
    this.saveExhibitorStand()
  }

  removeAssetId(idToRemove: string) {
    this.exhibitorStand.assetIds = this.exhibitorStand.assetIds.filter(id => id !== idToRemove)
    this.saveExhibitorStand()
  }

  async selectProgram(event: Event) {
    const rect = (<HTMLElement>event.target).getBoundingClientRect()
    const NO_PROGRAM_TITLE = `(No ${this.uiService.programTerm.text})`
    const data: ButtonListData<Program> = {
      x: rect.left,
      y: rect.top + 20,
      title: `Choose a ${this.uiService.programTerm.btn_lower}`,
      choiceObjects: Object.values(this.programs),
      choiceKey: 'title',
      selectedKey: 'id',
      selected: this.exhibitorStand.programId
    }
    const { selected, cancelled, submitted } = await openDialogGetResult<{selected: string, cancelled: boolean, submitted: boolean }>(this.dialog, ButtonListDialogComponent, { width: '250px', autoFocus: false,backdropClass: 'clear', data })
    if (!selected && !this.exhibitorStand.programId) return
    if (selected && this.exhibitorStand.programId === selected) return
    
    if (!selected) this.exhibitorStand.programId = null
    else this.exhibitorStand.programId = selected

    this.saveExhibitorStand()
  }

  async manageStandExhibitor(event: Event) {
    const rect = (<HTMLElement>event.target).getBoundingClientRect()
    const data: EntitySelectorData = {
      rect,
      entityName: 'Exhibitor',
      entityHolderName: 'Exhibitor stand',
      searchPlaceholder: 'Search or add exhibitor',
      limitSelectionToOne: true,
      entities: Object.values(this.exhibitors),
      selectedEntities: !!this.exhibitorStand.exhibitorId ? {[this.exhibitorStand.exhibitorId]: true} : {}
    }
    const returnData = await openDialogGetResult<string>(this.dialog, EntitySelectorDialogComponent, { width: '250px', autoFocus: false,backdropClass: 'clear', data })
    if (returnData) {
      const { selectedEntities } = data;
      console.log({ selectedEntities});
      const selected = Object.keys(selectedEntities).find( id => selectedEntities[id] );
      if (!selected && !this.exhibitorStand.exhibitorId) return
      if (selected && this.exhibitorStand.exhibitorId === selected) return
      
      if (!selected) this.exhibitorStand.exhibitorId = null
      else this.exhibitorStand.exhibitorId = selected

      this.saveExhibitorStand()
    }
  }

  async manageStandType(event: Event) {
    const rect = (<HTMLElement>event.target).getBoundingClientRect()
    const position =  {top: rect.bottom - 10, left: rect.left};
    const data: RankingDialogData = {
      position,
      ranks: this.event.standTypes,
      selectedRankId: this.exhibitorStand.standTypeId || null,
      type: 'Stand size'
    }
    const oldId = data.selectedRankId
    const oldRanksSerialized = JSON.stringify(data.ranks)
    const { selectedRankId, ranks } = await openDialogGetResult<{ selectedRankId: string, ranks: Ranking[] }>(this.dialog, RankSelectDialogComponent, { width: '300px', disableClose: false, data, backdropClass: 'clear' }) 
    if (JSON.stringify(ranks) !== oldRanksSerialized) {
      this.exhibitorService.updateStandTypes(ranks)
    }
    if (oldId !== selectedRankId) {
      this.exhibitorStand.standTypeId = selectedRankId || null
      this.saveExhibitorStand()
    }
  }

  setStandItemStatus(exhibitorId: string, status: ItemStatus, type: StandItemType & keyof this) {
    const standId = this.data.exhibitorStandId
    const shareable = this[type][`${standId}_${ exhibitorId }`]

    if (!shareable) {
      this.shareService.addNewSessionStandShareable(this.data.exhibitorStandId, exhibitorId, type)
      return;
    }
    

    const { id, key } = shareable
    const info: StandItemInfo = { id, key, exhibitorId: exhibitorId || null, standId, status }

    console.log({ standId, shareable, info })

    this.shareService.upsertShareInfo({ info }, id)
  }

  changeTab(tab) {
    this.selectedTab = tab
  }

  exit() {
    this.dialogRef.close()
  }

  deleteFromStand(exhibitorId) {
    // Deletion confirmation is nested in the status-wrapper component
    if (this.exhibitorStand.exhibitorId === exhibitorId) {
      this.exhibitorStand.exhibitorId = '';
      this.exhibitorService.updateExhibitorStand(this.exhibitorStand);
    }
  }

  updateExhibitorStandName(name: string) {
    this.exhibitorStand.name = name
    this.saveExhibitorStand()
  }

  saveExhibitorStand() {
    this.exhibitorService.updateExhibitorStand(this.exhibitorStand)
  }

  async deleteExhibitorStand(event) {
    this.dialogRef.close()
    this.exhibitorService.deleteExhibitorStand(this.exhibitorStand)
  }

  async duplicateExhibitorStand() {
    this.dialogRef.close()
    this.exhibitorService.duplicateExhibitorStand(this.exhibitorStand)
  }

}

export interface ManageExhibitorStandData {
  exhibitorStandId: string
  nested?: boolean
}
